import type {InfoNodes, InfoNodeId} from "#template/interfaces/info-nodes"
import type {BuilderOutlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {OnCompileContext} from "#template/template-node/types"
import type {TemplateNode} from "#template/template-node/template-node"

export function setupInfoNode<T extends InfoNodes.InfoNode>(
    node: TemplateNode,
    scope: GraphBuilderScope,
    context: OnCompileContext,
    typeName: T["type"],
    generator: (objectProps: {id: InfoNodeId}) => BuilderOutlet<T | null>,
) {
    const {currentTemplate} = context
    const {infoList, nodeToInfoMap} = currentTemplate

    const infoId = scope.genStructId(typeName)
    nodeToInfoMap.set(node, infoId)

    infoList.push(
        generator({
            id: infoId,
        }),
    )
}
